const ErrorMessage = {
  internalServerError: 'internalServerError',
  unAuthorized: 'unAuthorized',
  tooManyRequests: 'tooManyRequests'
}
export default ErrorMessage
